import React from 'react'
import { Chip, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { runSsnValidation } from '../../../../utils/validators'
import { usePatientFormContext } from '../../context/PatientFormContext'
import useStyles from './_styles/InsNumStyles'

import PatientFormField from '../PatientFormField'
import { patientFormErrors } from '../../_errors'
import { insNumMinLength, useFormContextPatient } from '../_utils'
import { DEFAULT_NO_VALUE } from '../../../Common/form/_utils/utils'

const InsNum = () => {
    const { control, watch } = useFormContextPatient()
    const classes = useStyles()

    const { state } = usePatientFormContext()

    const { ins } = state

    return (
        <Controller
            control={control}
            name="insNum"
            rules={{
                minLength: {
                    value: insNumMinLength,
                    message: patientFormErrors.insNum?.minLength ?? '',
                },
                maxLength: insNumMinLength,
                validate: (val) => {
                    if (val) {
                        const watched = {
                            birthDate: watch('birthDate'),
                            sex: watch('sex'),
                        }

                        return runSsnValidation({
                            ssn: val,
                            sex: watched?.sex?.toLocaleLowerCase() ?? 'i',
                            birthDate: watched.birthDate ?? '',
                        })
                    }

                    return undefined
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    label="Matricule INS"
                    labelSideComponent={
                        ins.oidType && (
                            <Chip
                                color="default"
                                clickable={false}
                                label={ins.oidType}
                                className={classes.insNumOidTypeChip}
                            />
                        )
                    }
                    tooltipTitle={
                        <Typography>
                            <b>INS : </b>Identifiant National de Santé récupéré automatiquement depuis le téléservice
                            INSi
                        </Typography>
                    }
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="PatientField"
                    {...field}
                    value={field.value ?? undefined}
                    placeholder={!field.value ? DEFAULT_NO_VALUE : undefined}
                    onChange={(e) => {
                        const diff = e.target.value.substring((field?.value ?? '').length)
                        if (diff && Number.isNaN(parseInt(diff))) {
                            return
                        }

                        field.onChange(e)
                    }}
                />
            )}
        />
    )
}

export default InsNum
